import { render, staticRenderFns } from "./ToolboxTalkDetails.vue?vue&type=template&id=2222fc24&scoped=true"
import script from "./ToolboxTalkDetails.vue?vue&type=script&lang=ts"
export * from "./ToolboxTalkDetails.vue?vue&type=script&lang=ts"
import style0 from "./ToolboxTalkDetails.vue?vue&type=style&index=0&id=2222fc24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2222fc24",
  null
  
)

export default component.exports